import React from 'react';
import { useParams, Link } from 'react-router-dom';
import toursData from '../components/data/tours.json';
import TripDetailHero from '../components/Trips/TripDetailHero';
import TripOverview from '../components/Trips/TripOverview';
import TripItinerary from '../components/Trips/TripItinerary';
import TripPricing from '../components/Trips/TripPricing';
import TripIncludedExcluded from '../components/Trips/TripIncludedExcluded';
import './TripDetailPage.css';

function TripDetailPage() {
  const { id } = useParams();
  
  // Find the tour by ID
  const tour = toursData.tours[id];

  if (!tour) {
    return (
      <div className="trip-detail-page">
        <div className="trip-not-found">
          <h2>Trip Not Found</h2>
          <p>The trip you're looking for doesn't exist.</p>
          <Link to="/trips" className="btn">Back to Trips</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="trip-detail-page">
      <TripDetailHero tour={tour} />
      <TripOverview tour={tour} />
      <TripItinerary tour={tour} />
      <TripPricing tour={tour} />
      <TripIncludedExcluded tour={tour} />
    </div>
  );
}

export default TripDetailPage;

